import type { ButtonProps, ButtonSize, ButtonStyle } from "ui/buttons/Button";
import Button from "ui/buttons/Button";
import styles from "./ButtonGroup.module.scss";

type ButtonGroupItem = Omit<ButtonProps, "btnSize" | "btnStyle" | "fullWidth"> & { isActive: boolean };

interface ButtonGroupProps {
  /** The style for active buttons in the group */
  activeBtnStyle?: ButtonStyle;
  /** The default style for all buttons in the group. */
  defaultBtnStyle?: ButtonStyle;
  /**
   * A list of button props for each button in the group, with some exceptions.
   * @see ButtonProps
   */
  items: ButtonGroupItem[];
  /** All buttons in the group will have this size. */
  size: ButtonSize;
}

/* @deprecated - use ToggleGroup from ui/forms/ToggleGroup instead */
export default function ButtonGroup({
  activeBtnStyle = "primary",
  defaultBtnStyle = "tertiary",
  items,
  size,
}: ButtonGroupProps) {
  return (
    <div className={styles.buttonGroup}>
      {items.map((item, index) => {
        const { isActive, ...rest } = item;
        return <Button key={index} btnSize={size} btnStyle={isActive ? activeBtnStyle : defaultBtnStyle} {...rest} />;
      })}
    </div>
  );
}
